import { WHATSAPP_URL } from "../lib/site";

const FloatingWhatsApp = () => (
    <a
        data-testid="floating-whatsapp"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Bath and Beyond on WhatsApp"
        className="fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center gap-3"
    >
        <span className="hidden sm:block rounded-full bg-noir/80 px-4 py-2 font-mono text-[10px] tracking-[0.2em] uppercase text-white/80 backdrop-blur border hairline-dark">
            Chat with us
        </span>
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-noir shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-105">
            <span className="wa-pulse absolute inset-0 rounded-full bg-[#25D366]" />
            <svg viewBox="0 0 24 24" className="relative h-7 w-7 fill-current" aria-hidden="true">
                <path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.96L2 22l5.18-1.5A9.9 9.9 0 1 0 12.04 2Zm5.78 14.06c-.24.68-1.4 1.3-1.94 1.35-.5.05-1.13.24-3.8-1.02-3.2-1.5-5.2-4.9-5.36-5.12-.15-.22-1.24-1.7-1.2-3.2.04-1.5.85-2.22 1.14-2.53.28-.3.62-.36.83-.35.24 0 .48 0 .69.02.22.01.52-.09.8.63.29.74.96 2.56 1.04 2.75.09.19.14.4.02.63-.12.24-.24.39-.42.6-.18.2-.38.36-.55.58-.17.2-.36.43-.16.8.2.37.9 1.53 1.94 2.47 1.33 1.22 2.45 1.58 2.8 1.75.34.18.55.15.75-.09.2-.24.87-1.01 1.1-1.36.23-.35.46-.28.77-.17.31.12 1.98.94 2.32 1.1.34.18.56.26.65.4.08.15.08.83-.16 1.51Z" />
            </svg>
        </span>
    </a>
);

export default FloatingWhatsApp;
